import bannersConfig from "../enum/bannersConfig";
import channels from "../enum/channels";
import { isControlChannel } from "../lib/utils";

const getBannerConfig = (media, channel) => {
  let bannerConfig = bannersConfig.DEFAULT;

  if ([channels.minhaclaro_web, channels.minhaclaro_web_nlog].includes(channel)) {
    bannerConfig = bannersConfig.MINHA_CLARO_WEB;
  }

  if ([channels.minhaclaro_app, channels.minhaclaro_app_nlog].includes(channel)) {
    bannerConfig = bannersConfig.MINHA_CLARO_APP;
  }

  if (isControlChannel(channel)) {
    bannerConfig = bannersConfig.CLARO_CONTROLE;
  }

  return media.mobile
    ? { src: bannerConfig.mobile, alt: bannerConfig.alt }
    : { src: bannerConfig.desktop, alt: bannerConfig.alt };
};

export { getBannerConfig };
